import React from 'react'
import PropTypes from 'prop-types'
import './NavBar.scss'
import MainNavBar from './MainNavBar'

const NavBar = props => {
  return (
    <div>
      <div className='navbar-placeholder' />
      <MainNavBar {...props} />
    </div>
  )
}

export default NavBar

NavBar.propTypes = {
  study: PropTypes.object,
  studies: PropTypes.array,
  location: PropTypes.object,
  modalProps: PropTypes.object,
  onLogout: PropTypes.func,
  navProps: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/layouts/NavBar/NavBar.js